import React from 'react';
import './buttonloader.css';

class ButtonLoader extends React.Component {
    render() {
        return (
            <div className="loading-container-small">
                <div className="loading-small"></div>
            </div>
        );
    }
}

export default ButtonLoader;